import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../mensajes";
import { AgylsoftModal } from "../../mensajes2";
import TablaConsultaGeneralDeudas from "../gestionComercial/tablaConsultaDeudaGeneral";

import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
} from "../../../util/varios";
import TablaDeudaComercio from "./tablaDeudaComercios";
import TablaPagosComercio from "./tablaPagosComercios";
import TablaFacturasContribuyente from "./tablaFacturasContribuyentes";
import TablaHistoricoRetenciones from "./tablaHistoricoRetenciones";
import TablaMultasComercio from "./tablaMultasComercios";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import TablaRelacionFacturas from "./tablaRelacionFacturas";
import TablaFacturasPagas from "./tablaRelacionFactPagadas";
import TablaOtrosPagosEtax from "./tablaOtroPagoEtax";
import TablaPagosEtax from "./tablaPagosEtax";
import axios from "axios";
import { Dimmer } from "../../spinner";
import TableHistorico from "./hitoricoDeclaracionesWeb";
import moment from "moment";
import { BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip } from "recharts";

export const ActualizarEstadoCuenta = (props) => {
  /*  variables de estados */

  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const anioActual = new Date().getFullYear();
  const anios = Array.from(new Array(7), (val, index) => anioActual - index);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [selectAnio, setSelectAnio] = useState(anioActual);
  const [mostrarGrafica, setMostrarGratica] = useState(false);
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [contar1, setContar1] = useState(0);
  const [activate, setActivate] = useState(false);
  const txtCodigoCiu = useRef();
  const txtIdactividad = useRef();
  const txtAlicuota = useRef();
  const txtDescripcionActi = useRef();
  const txtAnios = useRef();
  const txtMinimo = useRef();
  const txtActualizada = useRef();
  const txtCodActividad = useRef();
  const [deshabilitado, setDeshabilitado] = useState(false);
  const factorCambio = JSON.parse(localStorage.getItem("factorCambio"));

  const [datosGrafica, setDatosGrafica] = useState([]);
  const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
  const [jurada, setJurada] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [idUsuario, setIdUsuario] = useState();
  const [declaWeb, setDeclaWeb] = useState();
  const txtIdComercio = useRef();
  const txtRitm = useRef();
  const txtNumPatente = useRef();
  const txtDenominacionCome = useRef();
  const txtDireccionContri = useRef();
  const txtEmailContri = useRef();
  const txtCedula = useRef();
  const cmbStatus = useRef();
  const txtObserStatus = useRef();
  const [facturasPagadasEtax, setFacturasPagadasEtax] = useState();
  const [facturasOtrosPgosEtax, setFacturasOtrosPgosEtax] = useState();
  const [agyl, setAgyl] = useState({
    show: false,
    number: 0,
    contracts: [],
  });
  const handleCloseSi = () => {
    setMostrar1(false);
  };

  const handleCloseNo = () => {
    setMostrar1(false);
  };

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      if (event.target.id === "inputCodigo") {
        txtCodActividad.current.focus();
      } else if (event.target.id === "inputCodigoActi") {
        txtCodigoCiu.current.focus();
      } else if (event.target.id === "inputCodigoCiu") {
        txtAnios.current.focus();
      } else if (event.target.id === "inputAnio") {
        txtDescripcionActi.current.focus();
      } else if (event.target.id === "inputDescripcion") {
        txtAlicuota.current.focus();
      } else if (event.target.id === "inputActualizada") {
        btnAcepta.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      return false;
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const handleInputMontoChange = (event) => {
    //setActiveIndex(1);
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", "."),
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      /* if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(/\./g, "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      } */
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth,
        );
      }
      if (event.which === 13) {
        if (event.target.id === "inputAlicuota") {
          txtMinimo.current.focus();
        } else if (event.target.id === "inputMinimo") {
          txtActualizada.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const handleInputNumChange = (event) => {
    //setActiveIndex(1);
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.which === 13) {
        if (event.target.id === "inputAnio") {
          txtDescripcionActi.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const imprimirRelacionPago = () /*  => (event) */ => {
    /* event.preventDefault(); */

    var idcomercio = props.comercio.idcomercio;
    /* /siap?reporte=Planillacontricomercio&id=79&tipo=(2,34,69) */
    window.open(
      op.reportes +
        "/actividadeconomica?" +
        "reporte=RelPagoswebComercio" +
        "&id=" +
        idcomercio +
        "&tipo=(2,34,69)",
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  const salir = () => {
    setJurada([]);
    props.onHideCancela();
  };
  const handlerClickTab = (index, lastIndex, event) => {
    //alert("Tab seleccionado: " + index + " .\ Tab anterior seleccionado: " + lastIndex);
    if (operacion === 1 && (index === 2 || index === 3)) {
      setTabIndex(0);
    } else {
      setTabIndex(index);
    }
  };

  const apiagylsoft = (contri) => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/agylsoft/agylsoft?rif=${contri.rif.trim()}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.number_contracts > 0) {
            let contratos = response.data.contracts;
            let contracts = [];
            let tiene = false;
            let mesdesde = 0;
            let aniodesde = 0;

            let meshasta = 0;
            let aniohasta = 0;
            let num = 0;
            for (let i = 0; i < contratos.length; i++) {
              if (contratos[i].since !== false) {
                mesdesde = parseInt(contratos[i].since.split("-")[0]);
                aniodesde = parseInt(contratos[i].since.split("-")[1]);

                meshasta = parseInt(contratos[i].until.split("-")[0]);
                aniohasta = parseInt(contratos[i].until.split("-")[1]);
                num = 0;

                if (aniodesde === aniohasta) {
                  for (let x = mesdesde; x <= meshasta; x++) {
                    num = num + 1;
                  }
                } else {
                  for (let j = aniodesde; j <= aniohasta; j++) {
                    if (aniodesde === j) {
                      for (let x = mesdesde; x <= 12; x++) {
                        num = num + 1;
                      }
                    } else if (aniohasta === j) {
                      for (let x = 1; x <= meshasta; x++) {
                        num = num + 1;
                      }
                    } else {
                      for (let x = 1; x <= 12; x++) {
                        num = num + 1;
                      }
                    }
                  }
                }
              }

              if (num >= 3) {
                tiene = true;
                contracts.push(contratos[i]);
              }
            }

            if (tiene) {
              setAgyl({
                number: 2,
                contracts: contracts,
                show: true,
              });
            } else {
              setAgyl({
                number: 0,
                contracts: [],
                show: false,
              });
              //seleccionarDeuda(contri.idcontri);
            }
          } else if (response.data.number_contracts === 0) {
            setAgyl({
              number: 1,
              contracts: response.data.contracts,
              show: true,
            });
            //seleccionarDeuda(contri.idcontri);
          } else {
            setAgyl({
              number: 0,
              contracts: [],
              show: false,
            });
            //seleccionarDeuda(contri.idcontri);
          }
        }
      })
      .catch(() => {
        //seleccionarDeuda(contri.idcontri);
      })
      .finally(() => {
        setActivate(false);
      });
    /*if (response.data.debt > 0) {
            setAgyl({
              number: 2,
              name: response.data.name,
              identification: response.data.identification,
              debt: response.data.debt,
              since: response.data.since,
              until: response.data.until,
              contracts_count: response.data.contracts_count,
              show: true,
            });
          } else if (response.data.identification === null) {
            setAgyl({
              number: 1,
              name: response.data.name,
              identification: response.data.identification,
              debt: response.data.debt,
              since: response.data.since,
              until: response.data.until,
              contracts_count: response.data.contracts_count,
              show: true,
            });
          }
        }
      })
      .finally(() => {
        setActivate(false);
      });*/
  };

  const seleccionarHistoricoDeclaraciones = (idcom) => {
    let tipo = 2;
    if (op.nombre === "paez") {
      tipo = 3;
    }
    let endpoint =
      op.conexion + `/api/industria/djuradahist?idcom=${idcom}&tip=${tipo}`;

    // if (op.nombre === "paez") {
    //   endpoint =
    //     op.conexion + `/api/consultaweb/djuradahist?idcom=${idcom}&tip=3`;
    // }

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let tiene = false;
          setJurada(response.data);
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].estatus === "Por Pagar") {
              if (op.nombre === "satrimsca") {
                if (
                  response.data[i].nanio > 2023 &&
                  response.data[i].nmes > 3
                ) {
                  tiene = true;
                }
              } else if (op.nombre === "turen") {
                if (response.data[i].nanio > 2023) {
                  tiene = true;
                }
              } else {
                tiene = true;
              }
            }
          }
          setActivate(false);
        } else {
          setJurada([]);
        }
      })
      .catch(function (error) {
        setTitulo("notificación");
        setMsg(error.response);
        setMostrar(true);
        setActivate(false);
        setJurada([]);
      });
  };
  const procesarDatosGrafica = (data, anioSeleccionado) => {
    if (!data || data.length === 0) return [];

    const datosAgrupados = {};

    const ordenMeses = {
      ENERO: 0,
      FEBRERO: 1,
      MARZO: 2,
      ABRIL: 3,
      MAYO: 4,
      JUNIO: 5,
      JULIO: 6,
      AGOSTO: 7,
      SEPTIEMBRE: 8,
      OCTUBRE: 9,
      NOVIEMBRE: 10,
      DICIEMBRE: 11,
    };
    for (let i = 0; i < data.length; i++) {
      const registro = data[i];
      const montoPagar = registro.montopagar || 0;
      const tipo = registro.tipodecla;
      const nanio = registro.nanio;
      if (anioSeleccionado && nanio !== parseInt(anioSeleccionado)) {
        continue;
      }
      const nombreMes = registro.cmes
        ? registro.cmes.trim().toUpperCase()
        : null;
      if (!nombreMes || !(nombreMes in ordenMeses)) {
        continue;
      }

      if (!datosAgrupados[nombreMes]) {
        datosAgrupados[nombreMes] = {
          name: nombreMes,
        };
      }

      if (!datosAgrupados[nombreMes][tipo]) {
        datosAgrupados[nombreMes][tipo] = 0;
      }

      datosAgrupados[nombreMes][tipo] += montoPagar;
    }

    const resultadoAgrupado = Object.values(datosAgrupados).sort((a, b) => {
      return ordenMeses[a.name] - ordenMeses[b.name];
    });

    return resultadoAgrupado;
  };
  const imprimirPorcentaje = () => {
    window.open(
      `${op.reportes}/actividadeconomica?reporte=historico_pagos_porcentaje&ID=${props.comercio.idcomercio}`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };
  useEffect(() => {
    if (jurada && jurada.length > 0) {
      const datosFiltrados = procesarDatosGrafica(jurada, selectAnio);
      setDatosGrafica(datosFiltrados);
    } else {
      setDatosGrafica([]);
    }
  }, [jurada, selectAnio]);
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setSelectAnio(anioActual);
        setMostrarGratica(false);
        setActivate(false);
        setDeshabilitado(props.deshabilitado);
        setOperacion(props.operacion);
        seleccionarHistoricoDeclaraciones(props.comercio.idcomercio);
        setVisible(false);
        setIdUsuario(props.idusuario);
        setDeclaWeb(props.declaweb);
        setTabIndex(0);
        setContar1(0);
        if (op.agylsoft && parseInt(espiritu) === 11) {
          apiagylsoft(props.comercio);
        }
      }}
    >
      <Modal.Header className="azulGradiant">
        Consultar Estado Cuenta - Actividad Ecomica
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={salir}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <AgylsoftModal
          agyl={agyl}
          show={agyl.show}
          onHide={() => setAgyl({ ...agyl, show: false })}
        />
        <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <MensajeSiNo
          titulo={titulo2}
          mensaje={msg2}
          show={mostrar1}
          onHideSi={handleCloseSi}
          onHideNo={handleCloseNo}
        />
        <Dimmer active={activate}></Dimmer>
        <div>
          {!mostrarGrafica || jurada.length < 1 ? (
            <div className="row col-md-12 mx-auto tipo-letra">
              <fieldset className="row col-md-12 border-azul rounded mx-auto d-flex justify-content-between align-items-start">
                <legend className="float-none w-auto">
                  Deuda Contribuyente Industria y comercio
                </legend>
                <div className="col-8 d-flex justify-content-between row p-0 m-0">
                  <div className="col-12 d-flex justify-content-between row p-0 mx-auto my-2">
                    <div class="input-group input-group-sm my-auto col-md-3 m-0 p-0">
                      <span class="input-group-text" id="inputGroup-sizing-sm">
                        Código:
                      </span>
                      <input
                        type="text"
                        disabled={true}
                        ref={txtIdComercio}
                        className="form-control form-control-sm "
                        defaultValue={
                          props.comercio ? props.comercio.idcomercio : ""
                        }
                        id="inputCodigo"
                      />
                    </div>
                    <div class="input-group input-group-sm my-auto col-md-3 m-0 px-1 py-0">
                      <span class="input-group-text" id="inputGroup-sizing-sm">
                        RITM:
                      </span>
                      <input
                        type="text"
                        disabled={operacion === 1 ? true : deshabilitado}
                        ref={txtRitm}
                        className="form-control form-control-sm "
                        defaultValue={
                          props.comercio ? props.comercio.ritm.trim() : ""
                        }
                        id="inputRitm"
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                      />
                    </div>
                    <div class="input-group input-group-sm my-auto col-md-3 m-0 px-1 py-0">
                      <span class="input-group-text" id="inputGroup-sizing-sm">
                        Rif:
                      </span>
                      <input
                        type="text"
                        disabled={deshabilitado}
                        ref={txtNumPatente}
                        className="form-control form-control-sm "
                        defaultValue={props.comercio ? props.comercio.rif : ""}
                        id="inputNumPatente"
                        onKeyUp={handleInputNumChange}
                        onBlur={handleInputNumChange}
                      />
                    </div>
                    <div className="input-group input-group-sm col-md-3 m-0 p-0">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        {" "}
                        Status:
                      </span>
                      <select
                        name=""
                        disabled={deshabilitado}
                        ref={cmbStatus}
                        className="form-control form-control-sm "
                        defaultValue={
                          props.comercio
                            ? props.comercio.status !== null
                              ? props.comercio.status
                              : ""
                            : ""
                        }
                      >
                        {props.statuscome &&
                          props.statuscome.map((sta) => (
                            <option key={sta.idstatus} value={sta.idstatus}>
                              {sta.descripcion.trim()}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-12 d-flex justify-content-between row p-0 mx-auto my-2">
                    <div className="input-group input-group-sm col-md-12 mb-0  m-0 p-0">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        {" "}
                        Denominación Comercial:
                      </span>
                      <input
                        type="text"
                        disabled={deshabilitado}
                        ref={txtDenominacionCome}
                        className="form-control form-control-sm "
                        defaultValue={
                          props.comercio ? props.comercio.nombre.trim() : ""
                        }
                        id="inputDenoComer"
                        onKeyUp={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-12 d-flex justify-content-between row p-0 mx-auto my-2">
                    <div className="input-group input-group-sm col-md-12 mb-0 m-0 p-0">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Dirección del Contribuyente:
                      </span>
                      <textarea
                        type="textarea"
                        style={{ height: 70 }}
                        disabled={deshabilitado}
                        ref={txtDireccionContri}
                        className="form-control form-control-sm "
                        id="inputDireccionContri"
                        defaultValue={
                          props.comercio
                            ? props.comercio.direccion !== null
                              ? props.comercio.direccion.trim()
                              : ""
                            : ""
                        }
                        onKeyUp={handleInputChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-4 d-flex justify-content-between row p-0 m-0">
                  <div className="mb-2 p-0 mx-auto col-md-9">
                    <div className="col-md-12">
                      <div
                        className="position-relative text-center rounded"
                        style={{
                          border: "1px solid #777",
                          padding: "5px 10px 8px 10px",
                        }}
                      >
                        <h6
                          className="fw-bold position-absolute text-uppercase"
                          style={{
                            color: "#3b5998",
                            top: "-12px",
                            left: "10px",
                            backgroundColor: "white",
                            padding: "0 5px",
                            fontSize: "0.8rem",
                          }}
                        >
                          Unidad Cuenta Dinámica
                        </h6>
                        <div className="text-center">
                          <h1
                            className="fw-bold mb-0"
                            style={{ color: "#3b5998", fontSize: "1rem" }}
                          >
                            {formatMoneda(
                              factorCambio?.valor
                                ?.toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2,
                            )}
                          </h1>
                        </div>
                        <div
                          className="text-center mt-1"
                          style={{
                            backgroundColor: "#3b5998",
                            color: "white",
                            fontSize: "0.8rem",
                          }}
                        >
                          <span className="fw-bold">
                            Fecha Valor:{" "}
                            {moment
                              .utc(factorCambio?.fecha)
                              .format("DD/MM/YYYY")}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 p-0 m-0">
                    <div
                      className="position-relative my-2 p-0 mx-auto"
                      style={{
                        border: "1px solid #3b5998",
                        borderRadius: "8px",
                        maxWidth: "250px",
                      }}
                    >
                      <h6
                        className="fw-bold position-absolute text-uppercase mb-0"
                        style={{
                          color: "#3b5998",
                          top: "-10px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          backgroundColor: "white",
                          padding: "0 5px",
                          fontSize: "0.75rem",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Licencias
                      </h6>
                      <table
                        className="table table-sm table-borderless mb-0 text-center align-middle"
                        style={{ fontSize: "0.7rem" }}
                      >
                        <thead>
                          <tr style={{ color: "#3b5998" }}>
                            <th className="ps-2 text-start">Tipo</th>
                            <th>N°</th>
                            <th>Emisión</th>
                            <th className="pe-2">Vence</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* ── Comercio ── */}
                          <tr
                            style={
                              props.licenciaComercio &&
                              props.licenciaComercio.fechvence &&
                              moment(props.licenciaComercio.fechvence).isBefore(
                                moment(),
                                "day",
                              )
                                ? { backgroundColor: "#fff5f5" }
                                : {}
                            }
                          >
                            <td
                              className="ps-2 fw-bold text-start"
                              style={{ color: "#3b5998" }}
                            >
                              Comercio
                            </td>
                            <td className="fw-bold">
                              {(props.licenciaComercio &&
                                props.licenciaComercio.nrolicencia) || (
                                <span className="text-danger">S/N</span>
                              )}
                            </td>
                            <td>
                              {props.licenciaComercio &&
                              props.licenciaComercio.fechaemision ? (
                                moment
                                  .utc(props.licenciaComercio.fechaemision)
                                  .format("DD/MM/YY")
                              ) : (
                                <span className="text-danger">S/N</span>
                              )}
                            </td>
                            <td
                              className={
                                "fw-bold " +
                                (props.licenciaComercio &&
                                props.licenciaComercio.fechvence &&
                                moment(
                                  props.licenciaComercio.fechvence,
                                ).isBefore(moment(), "day")
                                  ? "text-danger"
                                  : "")
                              }
                            >
                              {props.licenciaComercio &&
                              props.licenciaComercio.fechvence ? (
                                moment
                                  .utc(props.licenciaComercio.fechvence)
                                  .format("DD/MM/YY")
                              ) : (
                                <span className="text-danger">S/N</span>
                              )}
                            </td>
                          </tr>

                          {/* ── Mantenimiento ── */}
                          <tr
                            style={
                              props.licenciaMantenimiento &&
                              props.licenciaMantenimiento.fechvence &&
                              moment(
                                props.licenciaMantenimiento.fechvence,
                              ).isBefore(moment(), "day")
                                ? { backgroundColor: "#fff5f5" }
                                : {}
                            }
                          >
                            <td
                              className="ps-2 fw-bold text-start"
                              style={{ color: "#3b5998" }}
                            >
                              Mantenim.
                            </td>
                            <td className="fw-bold">
                              {(props.licenciaMantenimiento &&
                                props.licenciaMantenimiento.nrocertif) || (
                                <span className="text-danger">S/N</span>
                              )}
                            </td>
                            <td>
                              {props.licenciaMantenimiento &&
                              props.licenciaMantenimiento.fechaemision ? (
                                moment
                                  .utc(props.licenciaMantenimiento.fechaemision)
                                  .format("DD/MM/YY")
                              ) : (
                                <span className="text-danger">S/N</span>
                              )}
                            </td>
                            <td
                              className={
                                "fw-bold " +
                                (props.licenciaMantenimiento &&
                                props.licenciaMantenimiento.fechvence &&
                                moment(
                                  props.licenciaMantenimiento.fechvence,
                                ).isBefore(moment(), "day")
                                  ? "text-danger"
                                  : "")
                              }
                            >
                              {props.licenciaMantenimiento &&
                              props.licenciaMantenimiento.fechvence ? (
                                moment
                                  .utc(props.licenciaMantenimiento.fechvence)
                                  .format("DD/MM/YY")
                              ) : (
                                <span className="text-danger">S/N</span>
                              )}
                            </td>
                          </tr>

                          {/* ── Licores (solo si llega) ── */}
                          {props.licenciaLicores && (
                            <tr
                              style={
                                props.licenciaLicores.fechvence &&
                                moment(
                                  props.licenciaLicores.fechvence,
                                ).isBefore(moment(), "day")
                                  ? { backgroundColor: "#fff5f5" }
                                  : {}
                              }
                            >
                              <td
                                className="ps-2 fw-bold text-start"
                                style={{ color: "#3b5998" }}
                              >
                                Licores
                              </td>
                              <td className="fw-bold">
                                {props.licenciaLicores.numlicencia || (
                                  <span className="text-danger">S/N</span>
                                )}
                              </td>
                              <td>
                                {props.licenciaLicores.fechaemision ? (
                                  moment
                                    .utc(props.licenciaLicores.fechaemision)
                                    .format("DD/MM/YY")
                                ) : (
                                  <span className="text-danger">S/N</span>
                                )}
                              </td>
                              <td
                                className={
                                  "fw-bold " +
                                  (props.licenciaLicores.fechvence &&
                                  moment(
                                    props.licenciaLicores.fechvence,
                                  ).isBefore(moment(), "day")
                                    ? "text-danger"
                                    : "")
                                }
                              >
                                {props.licenciaLicores.fechvence ? (
                                  moment
                                    .utc(props.licenciaLicores.fechvence)
                                    .format("DD/MM/YY")
                                ) : (
                                  <span className="text-danger">S/N</span>
                                )}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          ) : (
            <div className="card shadow-sm ">
              <div className="card-header bg-white border-0 pt-4 px-4">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                  <h5 className="mb-0 fw-semibold text-uppercase">
                    HISTORICO DE DECLARACIONES del Año {selectAnio}
                  </h5>
                  <div className="d-flex gap-2">
                    <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                      <span
                        className="input-group-text text-uppercase"
                        id="inputGroup-sizing-sm"
                      >
                        Año
                      </span>
                      <select
                        type="text"
                        className="form-control text-uppercase text-right"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        value={selectAnio}
                        onChange={(e) => setSelectAnio(e.target.value)}
                      >
                        {anios.map((e, index) => (
                          <option key={index} value={e}>
                            {e}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              {datosGrafica && datosGrafica.length > 0 && (
                <div className="card-body" style={{ fontSize: "10px" }}>
                  <BarChart responsive height={175} data={datosGrafica}>
                    <Tooltip
                      content={({ active, payload, label }) => {
                        if (active && payload && payload.length) {
                          return (
                            <div
                              style={{
                                backgroundColor: "white",
                                padding: "10px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "12px",
                              }}
                            >
                              <p
                                style={{
                                  margin: "0 0 5px 0",
                                  fontWeight: "bold",
                                }}
                              >
                                {label}
                              </p>
                              {payload.map((entry, index) => (
                                <p
                                  key={index}
                                  style={{
                                    margin: "5px 0",
                                    color: entry.color,
                                  }}
                                >
                                  {entry.name === "3"
                                    ? "Primera Quincena: "
                                    : entry.name === "4"
                                      ? "Segunda Quincena: "
                                      : ""}
                                  <strong>
                                    {formatMoneda(
                                      entry.value.toString().replace(".", ","),
                                      ",",
                                      ".",
                                      2,
                                    )}
                                    Bs.
                                  </strong>
                                </p>
                              ))}
                            </div>
                          );
                        }
                        return null;
                      }}
                    />
                    <Bar
                      dataKey="2"
                      fill="#3d8bfd"
                      activeBar={{ fill: "#2563eb", stroke: "#2563eb" }}
                    />
                    <Bar
                      dataKey="3"
                      fill="#3d8bfd"
                      activeBar={{ fill: "#2563eb", stroke: "#2563eb" }}
                    />
                    <Bar
                      dataKey="4"
                      fill="#82ca9d"
                      activeBar={{ fill: "#5aad7d", stroke: "#5aad7d" }}
                    />
                    <CartesianGrid stroke="#ccc" />
                    <XAxis dataKey="name" />
                    <YAxis />
                  </BarChart>
                </div>
              )}
            </div>
          )}

          <ul className="nav mt-3" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link active bg-blue-100 text-light"
                id="datosTributarios"
                data-bs-toggle="tab"
                data-bs-target="#tributarios"
                type="button"
                role="tab"
                aria-controls="tributarios"
                aria-selected="true"
                onClick={() => setMostrarGratica(false)}
              >
                Deudas Industria y Comercio
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-200 text-light"
                id="deuda-tab"
                data-bs-toggle="tab"
                data-bs-target="#deuda"
                type="button"
                role="tab"
                aria-controls="deuda"
                aria-selected="false"
                onClick={() => setMostrarGratica(false)}
              >
                Historico Pagos
              </a>
            </li>

            {props.comercio && props.comercio.esagentereten ? (
              <li className="nav-item" role="presentation">
                <a
                  className="rounded nav-link bg-blue-400 text-light"
                  id="multas-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#multas"
                  type="button"
                  role="tab"
                  aria-controls="multas"
                  aria-selected="false"
                  onClick={() => setMostrarGratica(false)}
                  style={{
                    fontFamily: "Times New Roman, Times, serif",
                    fontSize: "15px",
                    fontWeight: "bold",
                  }}
                >
                  Historico Pago Retenciones
                </a>
              </li>
            ) : (
              ""
            )}

            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-500 text-light"
                id="relacion-tab"
                data-bs-toggle="tab"
                data-bs-target="#relacion"
                type="button"
                role="tab"
                aria-controls="relacion"
                aria-selected="false"
                onClick={() => setMostrarGratica(false)}
              >
                Deuda Multas
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-600 text-light"
                id="factpag-tab"
                data-bs-toggle="tab"
                data-bs-target="#factpag"
                type="button"
                role="tab"
                aria-controls="factpag"
                aria-selected="false"
                onClick={() => setMostrarGratica(false)}
              >
                Relación Fact. Pagadas
              </a>
            </li>
            {parseInt(espiritu) === 11 ? (
              <li className="nav-item" role="presentation">
                <a
                  className="rounded nav-link bg-blue-900 text-light"
                  id="factpag-tab2"
                  data-bs-toggle="tab"
                  data-bs-target="#factpag2"
                  type="button"
                  role="tab"
                  aria-controls="factpag2"
                  aria-selected="false"
                  onClick={() => setMostrarGratica(false)}
                >
                  Declaraciones Etax.
                </a>
              </li>
            ) : (
              ""
            )}
            {parseInt(espiritu) === 11 ? (
              <li className="nav-item" role="presentation">
                <a
                  className="rounded nav-link bg-blue-900 text-light"
                  id="factpag-tab3"
                  data-bs-toggle="tab"
                  data-bs-target="#factpag3"
                  type="button"
                  role="tab"
                  aria-controls="factpag3"
                  aria-selected="false"
                  onClick={() => setMostrarGratica(false)}
                >
                  Otros Pagos Etax.
                </a>
              </li>
            ) : (
              ""
            )}
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-600 text-light"
                id="hisdeclaweb-tab"
                data-bs-toggle="tab"
                data-bs-target="#hisdeclaweb"
                type="button"
                role="tab"
                aria-controls="hisdeclaweb"
                aria-selected="false"
                onClick={() => setMostrarGratica(true)}
              >
                Historico Declaraciones
              </a>
            </li>
            <button
              className="btn btn-sm btn-info rounded-pill col-md-2 ml-auto"
              onClick={imprimirRelacionPago}
            >
              <i className="fa fa-print"> Pagos Web</i>{" "}
            </button>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="tributarios"
              role="tabpanel"
              aria-labelledby="datosTributarios"
            >
              <TablaDeudaComercio
                tabdeuda={props.tabdeuda}
                credito={props.comercio ? props.comercio.credito : "0,00"}
                idcomercio={props.comercio ? props.comercio.idcomercio : ""}
              />
            </div>

            <div
              className="tab-pane fade"
              id="deuda"
              role="tabpanel"
              aria-labelledby="deuda-tab"
            >
              <TablaPagosComercio
                tabpago={props.tabpago}
                idcomercio={props.comercio ? props.comercio.idcomercio : ""}
              />
            </div>

            {props.comercio && props.comercio.esagentereten ? (
              <div
                className="tab-pane fade"
                id="multas"
                role="tabpanel"
                aria-labelledby="multas-tab"
              >
                <TablaHistoricoRetenciones
                  tabreten={props.tabreten}
                  operacion={props.operacion}
                  espiritu={props.espiritu}
                />
              </div>
            ) : (
              ""
            )}

            <div
              className="tab-pane fade"
              id="relacion"
              role="tabpanel"
              aria-labelledby="relacion-tab"
            >
              <TablaMultasComercio
                tabmulta={props.tabmulta}
                idcomercio={props.comercio ? props.comercio.idcomercio : ""}
              />
            </div>

            <div
              className="tab-pane fade"
              id="factpag"
              role="tabpanel"
              aria-labelledby="factpag-tab"
            >
              <TablaFacturasPagas
                tabfacC={props.factpago}
                idcomercio={props.comercio ? props.comercio.idcomercio : ""}
              />
            </div>
            <div
              className="tab-pane fade"
              id="factpag2"
              role="tabpanel"
              aria-labelledby="factpag-tab2"
            >
              <TablaPagosEtax tabreten={props.factpagoetax} />
            </div>
            <div
              className="tab-pane fade"
              id="factpag3"
              role="tabpanel"
              aria-labelledby="factpag-tab3"
            >
              <TablaOtrosPagosEtax tabreten={props.factotropagoetax} />
            </div>
            <div
              className="tab-pane fade"
              id="hisdeclaweb"
              role="tabpanel"
              aria-labelledby="hisdeclaweb-tab"
            >
              <TableHistorico
                post={jurada}
                idcomercio={props.comercio ? props.comercio.idcomercio : ""}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-info rounded-pill mx-2"
          onClick={() => imprimirPorcentaje()}
        >
          <i className="fas fa-print m-0" />
        </button>
        <button
          ref={btnAcepta}
          onClick={() => setMostrarModal(true)}
          className="btn btn-sm btn-primary rounded-pill"
        >
          <i className="fas fa-search"> Ver Deuda General</i>
        </button>
        <button
          ref={btnCancela}
          onClick={salir}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Salir </i>
        </button>
      </Modal.Footer>
      <Modal
        show={mostrarModal}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      >
        <TablaConsultaGeneralDeudas
          modal={true}
          estadoCuenta={true}
          solvencia={false}
          codigo={props.comercio?.idcomercio}
          show={() => setMostrarModal(false)}
        />
      </Modal>
    </Modal>
  );
};
